/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import './settings';
import {polyfill} from "seamless-scroll-polyfill";
import {dispatchCustomEvent, IndexedObject, log} from '@dvrd/dvr-controls';
import {setDeviceId} from "./utils";

declare global {
    interface Window {
        log: Function;
        mode: string;
        settings: IndexedObject<any>;
        modeSettings: { [index: string]: any };
        dce: Function;
        allowCookies: boolean;
        dataLayer: any;
        gtag?: Function;
    }
}

polyfill();
setDeviceId();
window.allowCookies = true;
window.dce = (event: string, data?: any) => {
    dispatchCustomEvent(event, data);
};